import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Icon, ICONS } from '@nimbus-library/features/shared/resources/icons';

export type NimbusInfoBannerVariant = 'success' | 'info' | 'warning' | 'error';
export type NimbusInfoBannerSize = 'small' | 'large';

const VARIANT_ICONS: Record<NimbusInfoBannerVariant, Icon> = {
  success: ICONS.CHECK_CIRCLE,
  info: ICONS.INFO_CIRCLE,
  warning: ICONS.EXCLAMATION_TRIANGLE,
  error: ICONS.TIMES_CIRCLE,
};

@Component({
  standalone: false,
  selector: 'nimbus-info-banner',
  templateUrl: './nimbus-info-banner.component.html',
  styleUrls: ['./nimbus-info-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusInfoBannerComponent {
  @Input() public variant: NimbusInfoBannerVariant = 'info';
  @Input() public size: NimbusInfoBannerSize = 'large';
  @Input() public icon?: Icon;

  @HostBinding('class')
  public get hostClass(): string {
    return `nimbus-info-banner-${this.variant} nimbus-info-banner-${this.size}`;
  }

  public get iconToRender(): Icon {
    return this.icon ?? VARIANT_ICONS[this.variant];
  }
}
